export const mutationType = {
    READY: 'READY',
    SNACKBAR: 'SNACKBAR',
    TITLEPAGE: 'TITLEPAGE',
    APP: 'APP',
    PAGE_START_LOADING: 'PAGE_START_LOADING',
    PAGE_STOP_LOADING: 'PAGE_STOP_LOADING',
    SET_LEVEL: 'SET_LEVEL',
}
